__turbopack_context__.v({
  "fadeOut": "crossfade-module__C6UKPa__fadeOut",
});
